import moment from 'moment';
import { MONTHS } from '../constants/dates';

export const getTimeFormat = time => moment(time, 'HH:mm').format('HH:mm');

/** Returns yesterday */
export const getYesterday = () => {
  const today = moment()
    .subtract(1, 'days')
    .format('YYYY-MM-DD');
  return today;
};

export const getMonth = date => {
  const newDate = date ? new Date(date) : new Date();
  const month = MONTHS[newDate.getMonth()];
  return month;
};

export const getLiteralMonth = month => MONTHS[month];

export const getObjDate = date => {
  const newDate = new Date(date);
  return {
    day: newDate.getDate(),
    month: newDate.getMonth(),
    year: newDate.getFullYear()
  };
};

export const getBasicDate = date => moment(date).format('DD-MM-YYYY');
export const getMonthDate = date => moment(date).format('MM-DD-YYYY');
export const getDay = date => moment(date).format('DD');

export const convertDateToBBDDFormat = date =>
  moment(date).format('YYYY-MM-DD[T]HH:mm:ss[Z]');

export const getWeekday = day => {
  const days = [
    'domingo',
    'lunes',
    'martes',
    'miercoles',
    'jueves',
    'viernes',
    'sabado'
  ];
  return days[day];
};

export const getMonthName = month => {
  const months = [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre'
  ];
  return months[month];
};

export const getFormattedDay = day => (day < 10 ? `0${day}` : `${day}`);

export const convertDateToUTC = date =>
  moment.utc(date).format('YYYY-MM-DD[T]HH:mm:ss[Z]');
